module.exports = __webpack_public_path__ + "assets/img/discernment_id_card_scene1.9be2cf2e.png";